import { createAction } from 'redux-act';

export const updatePresentation = createAction();
export const updatePresentationFields = createAction();
export const updatePresentationPreview = createAction();
export const updatePresentationLocale = createAction();
export const clearPresentation = createAction();
export const updatePresentationUrl = createAction();
export const updateIndexH = createAction();
export const updateQuestionSet = createAction();
